import { breakpoints } from './breakpoints'
import { colors } from './colors'
import { variables } from './variables'

export const theme = { breakpoints, colors, variables }
